<div class="modal" [class.is-active]="show">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <span class="icon"><i class="fa fa-dna"></i></span>
        Add Custom Genes
      </p>
      <button (click)="close()" class="delete" aria-label="close"></button>
    </header>
    <section class="modal-card-body">
      <div class="notification is-success" *ngIf="addedCount > 0">
        {{addedCount}} genes have been added to the selection.
        <div *ngIf="itemsFound.length > addedCount && !selectOnly">
          {{itemsFound.length - addedCount}} genes have already been selected before.
        </div>
        <div *ngIf="itemsFound.length > addedCount && selectOnly">
          {{itemsFound.length - addedCount}} genes either have been selected already or did not appear in the current graph.
        </div>
      </div>

      <div class="notification is-warning" *ngIf="notCancerGenes.length">
        <div>
          The following {{notCancerGenes.length}} items have been selected but are no typical cancer genes:
          <ul><li class="not-cancer-genes" *ngFor="let ncg of notCancerGenes">{{ncg}}</li></ul>
        </div>
      </div>
      <div class="notification is-warning" *ngIf="itemsFound.length > 0 && addedCount === 0">
        <div *ngIf="itemsFound.length > addedCount && !selectOnly">
          {{itemsFound.length - addedCount}} genes have already been selected before.
        </div>
        <div *ngIf="itemsFound.length > addedCount && selectOnly">
          {{itemsFound.length - addedCount}} genes either have been selected already or did not appear in the current graph.
        </div>
      </div>
      <div class="notification is-danger" *ngIf="notFound.length > 0">
        The following {{notFound.length}} items could not be found and have been ignored:
        <ul><li class="not-found" *ngFor="let nf of notFound">{{nf}}</li></ul>
      </div>
      <div class="field">
        <label class="label" for="gene-list">List of items (Entrez ids, HUGO names or Uniprot ids)</label>
        <div class="control">
          <textarea class="input" [ngModel]="textList" (ngModelChange)="changeTextList($event)" id="gene-list">
          </textarea>
        </div>
      </div>
      <p *ngIf="genes">
        Items parsed: {{genes.length}}
      </p>
      
      <label class="checkbox has-tooltip-right" 
      data-tooltip="Will be slow for larger gene lists.
Seeds can be uploaded for tasks
without being added to the network.">
        <input type="checkbox" [checked]="addMissinGenesToNetwork" (change)="addMissinGenesToNetwork = !addMissinGenesToNetwork">
        Add genes to network
      </label>
    </section>

    <footer class="modal-card-foot">
      <button (click)="addGenes();" class="button is-success has-tooltip-right"
              data-tooltip="Add all to the selection."
              [disabled]="genes.length === 0 || loading">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>
          Add
        </span>
      </button>
      <button (click)="addVisibleGenes();" class="button is-success has-tooltip"
              data-tooltip="Add to selection if they appear in the current network."
              [disabled]="genes.length === 0 || loading">
        <span class="icon">
          <i class="fas fa-expand"></i>
        </span>
        <span>
          Select
        </span>
      </button>
      <button (click)="close()" class="button   has-tooltip" data-tooltip="Close the current window.">Close
      </button>
    </footer>
  </div>
</div>
